(function() {
  const colorSchemes = {
    'scheme-1': { bg: '#F70D0D', color: '#161616', colorRgb: '249,245,239', button: '#F9F5EF', buttonText: '#161616' },
    'scheme-2': { bg: '#1a1a1a', color: '#F9F5EF', colorRgb: '249,245,239', button: '#F9F5EF', buttonText: '#161616' },
    'scheme-3': { bg: '#F70D0D', color: '#F9F5EF', colorRgb: '249,245,239', button: '#F9F5EF', buttonText: '#161616' },
    'scheme-4': { bg: '#1a1a1a', color: '#F9F5EF', colorRgb: '249,245,239', button: '#F9F5EF', buttonText: '#161616' }
  };

  const resetStyles = () => {
    const root = document.documentElement;
    const body = document.body;

    body.style.backgroundColor = '';
    body.style.color = '';
    body.dataset.colorSchemeAnimation = false;

    root.style.removeProperty('--color-foreground-animation');
    root.style.removeProperty('--color-foreground-rgb-animation');
    root.style.removeProperty('--color-primary-button-animation');
    root.style.removeProperty('--color-primary-button-text-animation');
    
    body.dataset.colorSchemeActive = "false";
  };

  const applyStyles = (schemeKey) => {
    const scheme = colorSchemes[schemeKey];
    if (!scheme) {
      resetStyles();
      return;
    }

    const root = document.documentElement;
    const body = document.body;

    body.style.backgroundColor = scheme.bg;
    body.style.color = scheme.color;
    body.dataset.colorSchemeAnimation = true;

    root.style.setProperty('--color-foreground-animation', scheme.color);
    root.style.setProperty('--color-foreground-rgb-animation', scheme.colorRgb);
    root.style.setProperty('--color-primary-button-animation', scheme.button);
    root.style.setProperty('--color-primary-button-text-animation', scheme.buttonText);
    
    body.dataset.colorSchemeActive = "true";
  };

  const initObserver = () => {
    const allSections = document.querySelectorAll('.shopify-section');

    const observerOptions = {
      rootMargin: '-50% 0px -50% 0px', // Trigger bei Bildschirmmitte
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const backgroundElement = entry.target.querySelector('.section-background');
          const schemeKey = backgroundElement ? backgroundElement.dataset.colorSchemeAnimation : null;

          if (schemeKey && colorSchemes[schemeKey]) {
            applyStyles(schemeKey);
          } else {
            resetStyles();
          }
        }
      });
    }, observerOptions);

    allSections.forEach(section => observer.observe(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  document.addEventListener('shopify:section:load', initObserver);
})();